import { render, staticRenderFns } from "./MenuPages.vue?vue&type=template&id=2892804f&scoped=true&"
import script from "./MenuPages.vue?vue&type=script&lang=js&"
export * from "./MenuPages.vue?vue&type=script&lang=js&"
import style0 from "./MenuPages.vue?vue&type=style&index=0&id=2892804f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892804f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
